module.exports = __webpack_public_path__ + "static/media/mortadelaymedia.7530ed1d.webp";